import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';
import { theme } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';

function SearchProforma(props) {
  const [proforma, setProforma] = useState(null);
  const [proformas, setProformas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    if(props.client){
      fetchProformas();
    }
  }, [props.client]);

  const fetchProformas = () => {
    setLoading(true);
    axios.get(global.config.api_server+'proformas?q=client.client_id;'+props.client+'&token='+localStorage.getItem("token"))
    .then(res => {
      if(res.status === 200){
        setLoading(false);
        const proformas = res.data.proformas;
        if(proformas === null || proformas === undefined){
          alertService.error("Error fetching proformas");
        }else{
          setProformas(proformas);
        }
      }
    }).catch(err => {
        setLoading(false);
        alertService.error(err);
    });
  }

  const updateProforma = (id) =>{
    for(let i = 0;i < proformas.length;i++){
        if(proformas[i].proforma_id === id){
            setProforma(proformas[i]);
            props.handleSubmit(proformas[i]);
            break;
        }
    }
  }
  
  if(loading){
    return <Progress label='Fetching proformas'/>;
  }else{
    return(
      <div>
        <label>Proforma(s): {proformas.length <= 0 ? <span>No Proforma found</span> : <span>click to select</span>}</label>
        <div className="row">
            {proformas.map(prof =>
              <div className="col-md-3" key={prof.proforma_id}>
                <div className={'card clip-card clip-card-'+theme() + (proforma && proforma.proforma_id === prof.proforma_id ? ' selected' : '')} onClick={(e) => updateProforma(prof.proforma_id)}>
                  <div class="card-body">
                    <h5 class="card-title">Proforma Id: {prof.proforma_id}</h5>
                    <p class="card-text">Total Amount: {prof.amount}</p>
                    <p class="card-text">Currency: {prof.currency}</p>
                    <p class="card-text">Date: {prof.updation_date}</p>
                  </div>
                </div>
              </div>
            )}
        </div>
        <hr/>
      </div>
    )
  }
}

export default SearchProforma;